export enum BlockItemType {
  Ads,
  Images,
}
